import React from 'react';
import CollaborationExplorer from './CollaborationExplorer';

function App() {
  return (
    <div className="App">
      <CollaborationExplorer />
    </div>
  );
}

export default App;
